__turbopack_context__.v({
  "flushBottom": "BlockProductPairings-module-scss-module__owAI_W__flushBottom",
  "flushTop": "BlockProductPairings-module-scss-module__owAI_W__flushTop",
  "inner": "BlockProductPairings-module-scss-module__owAI_W__inner",
  "lastBlock": "BlockProductPairings-module-scss-module__owAI_W__lastBlock",
  "root": "BlockProductPairings-module-scss-module__owAI_W__root",
});
